export interface ImagingPreferences {
  imagingLevel: EImagingLevel;
  wellNumber: number;
  dropNumber: number;
  requestedCaptureProfileIds: string[];
}

export enum EImagingLevel {
  Drop,
  InterestingDrop,
  Plate,
}

